import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-df45fa90"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "p-px-3"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "แจ้งคืนสินค้า", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "return-request-product-panel"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "return-request-finance-panel p-mt-2" }
const _hoisted_7 = { class: "return-request-contact-panel p-mt-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "m-80px" }, null, -1))
const _hoisted_9 = {
  key: 3,
  class: "return-footer p-px-3 p-pt-2"
}
const _hoisted_10 = { class: "p-d-flex p-jc-between" }
const _hoisted_11 = { class: "w-100 p-pt-2 p-pr-1" }
const _hoisted_12 = { class: "w-100 p-pt-2 p-pl-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnProductDetail = _resolveComponent("ReturnProductDetail")!
  const _component_ReturnProductDetailDisplay = _resolveComponent("ReturnProductDetailDisplay")!
  const _component_ReturnRequestDetail = _resolveComponent("ReturnRequestDetail")!
  const _component_ReturnContactPanel = _resolveComponent("ReturnContactPanel")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isDisplay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (!_ctx.isDisplay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_ReturnProductDetail)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_ReturnProductDetailDisplay, { isDisplayProduct: true })
        ])),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_ReturnRequestDetail, { isDisplay: _ctx.isDisplay }, null, 8, ["isDisplay"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_ReturnContactPanel, { isDisplay: _ctx.isDisplay }, null, 8, ["isDisplay"])
    ]),
    _hoisted_8,
    (!_ctx.isDisplay)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_Button, {
                label: "ยกเลิก",
                class: "p-button-outlined p-button-danger w-100"
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_Button, {
                label: "ทำรายการต่อ",
                class: "w-100 p-button-danger",
                onClick: _ctx.setReturnStep
              }, null, 8, ["onClick"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}